import React from 'react'
import Sidebar from '../Component/Sidebar/Sidebar'
import Dashboard from '../Component/Dashboard/Dashboard'

export const Dashboardpage = () => {
  return (
    <div>
        <Sidebar>
            <Dashboard/>
        </Sidebar>
    </div>
  )
}
